import { PaymentGateway } from '../../interface/payment-gateway.interface';

/**
 * Payment Gateway APIs
 */
const paymentGatewayApi = {
  /**
   * configure payment gateway
   * @param {any} gatewayType - The gatewayType
   */
  configurePaymentGateway: (gatewayType: string) => {
    let MOCKRESPONSE: any = null;

    switch (gatewayType) {
      case 'stripe':
        MOCKRESPONSE = {
          data: [
            {
              fieldName: 'secret_key',
              label: 'Secret Key',
              placeholder: 'Enter your Stripe Secret Key',
              required: true,
              fieldType: 'password',
              description: 'Stripe Secret Key',
            },
            {
              fieldName: 'publishable_key',
              label: 'Publishable Key',
              placeholder: 'Enter your Stripe Publishable Key',
              required: true,
              fieldType: 'password',
              description: 'Stripe Publishable Key',
            },
            {
              fieldName: 'webhook_secret',
              label: 'Webhook Key',
              placeholder: 'Enter your Webhook Secret',
              required: false,
              fieldType: 'password',
              description: 'Stripe Webhook Key',
            },
            {
              fieldName: 'status',
              label: 'Status',
              placeholder: '',
              required: true,
              fieldType: 'radio',
              description: '',
            },
          ],
        };
        break;
      case 'hyper-pay':
        return {
          data: [
            {
              fieldName: 'api_endpoint',
              label: 'API Endpoint',
              placeholder: 'Enter your HyperPay API Endpoint',
              required: true,
              fieldType: 'string',
              description: 'API Endpoint',
            },
            {
              fieldName: 'initial_entity_id',
              label: 'Initial Entity ID',
              placeholder: 'Enter your Initial Entity ID',
              required: true,
              fieldType: 'password',
              description: 'Initial Entity ID',
            },
            {
              fieldName: 'repeated_entity_id',
              label: 'Repeated Entity ID',
              placeholder: 'Enter your Repeated Entity ID',
              required: true,
              fieldType: 'password',
              description: 'Repeated Entity ID',
            },
            {
              fieldName: 'status',
              label: 'Status',
              placeholder: '',
              required: true,
              fieldType: 'radio',
              description: '',
            },
          ],
        };

      default:
        return {
          data: [],
        };
    }

    return new Promise<any>((resolve) => {
      setTimeout(() => {
        resolve(MOCKRESPONSE);
      }, 500);
    });
  },
  /**
   * Fetch all payment gateways
   */
  getGateways: async (): Promise<PaymentGateway[]> => {
    // return baseApi.get('/payment-gateways');
    // Mock response for now
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            id: '1',
            name: 'Stripe',
            logo: 'S',
            supportedMethods: 'Credit Card, Apple Pay, Google Pay, PayPal',
            status: 'Active',
            isActive: true,
            lastUpdated: '24 May 2026 | 03:00 pm',
            businessType: 'B2B',
          },
          {
            id: '2',
            name: 'Stripe',
            logo: 'S',
            supportedMethods: 'Credit Card, Apple Pay, Google Pay, PayPal',
            status: 'Inactive',
            isActive: false,
            lastUpdated: '24 May 2026 | 03:00 pm',
            businessType: 'B2C',
          },
        ]);
      }, 500);
    });
  },

  /**
   * Toggle gateway status
   * @param {any} id - The id
   * @param {any} isActive - The isActive
   */
  toggleGatewayStatus: async (id: string, isActive: boolean): Promise<any> => {
    // return baseApi.put(`/payment-gateways/${id}/status`, { isActive });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true });
        console.log(id, isActive);
      }, 300);
    });
  },
};

export default paymentGatewayApi;
